import { create } from 'zustand';

interface IUiActionsStore {
  hideMobileDrawer: boolean;
  setHideMobileDrawer: (open: boolean) => void;
}

export const useUiActionsStore = create<IUiActionsStore>((set, get) => ({
  hideMobileDrawer: false,

  setHideMobileDrawer: (hide: boolean) =>
    set(() => ({
      hideMobileDrawer: hide,
    })),
}));
